export enum AccountingJobTypeEnum {
  BALANCES_LOGS = 'BALANCES_LOGS',
  BALANCE_SHEET = 'BALANCE_SHEET',
  REVALUATION = 'REVALUATION',
  POST_PROCESSING = 'POST_PROCESSING',
}

export enum AccountingJobStateEnum {
  NEW = 'NEW',
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
}

export interface AccountingJob {
  periodFrom: string;
  periodTo: string;
  accountsIds?: string[];
  balancesLogsCurrentDate?: string;
  balanceSheetCurrentDate?: string;
  revaluationCurrentDate?: string;
  postProcessingCurrentDate?: string;
  fullCurrentDate?: string;
  progress?: string;
  type: AccountingJobTypeEnum;
  state: AccountingJobStateEnum;
  id: string;
  createdAt?: string;
  updatedAt?: string;
  startedAt?: string;
  finishedAt?: string;
  cancelledAt?: string;
  duration?: string;
  url?: string;
  render?: Record<string, React.JSX.Element>;
}

export interface AccountingJobTypes {
  accountingJobsIsLoading?: boolean;
  accountingJob?: AccountingJob;
  jobsLength?: number;
  query: string;
  withoutMargin?: boolean;
  accountingJobs?: AccountingJob[];
}
